import { defineStore } from 'pinia';

export const useBlockerStore = defineStore('coveBlocker', {
  state () {
    return {
      delay: 0,
      visible: false
    };
  }
});